export default (Component, name) => {
  Component.muiName = name
  return Component
}
